/* ==========================================================================
   WOD.LOL — page d'accueil v2 : rails (flèches + barre de progression),
   onglets best-sellers, ligne d'info des cartes, vidéos lancées à l'écran,
   texte « L'ADN » repliable.
   ========================================================================== */
(() => {
  if (window.__wlHome) return;
  window.__wlHome = true;
  document.body.classList.add('wl-home-page');

  /* ---------- Rails ---------- */
  const initRail = (rail) => {
    const track = rail.querySelector('[data-track]');
    if (!track) return;
    const bar = rail.querySelector('[data-bar] span');
    const prev = rail.querySelector('[data-prev]');
    const next = rail.querySelector('[data-next]');
    let raf = 0;
    const sync = () => {
      raf = 0;
      const max = track.scrollWidth - track.clientWidth;
      const ratio = track.clientWidth / Math.max(track.scrollWidth, 1);
      if (bar) {
        bar.style.setProperty('--w', Math.max(ratio * 100, 12) + '%');
        bar.style.setProperty('--l', (max > 0 ? (track.scrollLeft / max) * (100 - Math.max(ratio * 100, 12)) : 0) + '%');
        bar.parentElement.style.visibility = max > 4 ? 'visible' : 'hidden';
      }
      if (prev) prev.disabled = track.scrollLeft < 4;
      if (next) next.disabled = track.scrollLeft > max - 4;
    };
    track.addEventListener('scroll', () => raf || (raf = requestAnimationFrame(sync)), { passive: true });
    addEventListener('resize', sync);
    const step = (dir) => {
      const item = [...track.children].find((c) => !c.hidden);
      const w = item ? item.getBoundingClientRect().width + 10 : track.clientWidth * 0.8;
      track.scrollBy({ left: dir * Math.max(w, Math.floor(track.clientWidth / w) * w), behavior: 'smooth' });
    };
    if (prev) prev.addEventListener('click', () => step(-1));
    if (next) next.addEventListener('click', () => step(1));
    rail.__sync = sync;
    sync();
  };
  document.querySelectorAll('[data-wl-rail]').forEach(initRail);

  /* ---------- Cartes produit : « Oversize · Délavé · 285 g/m² » ---------- */
  document.querySelectorAll('.wl-pc[data-fit]').forEach((c) => {
    const m = c.querySelector('[data-meta]');
    if (!m) return;
    const d = c.dataset;
    const bits = [];
    if (d.fit) bits.push(d.fit);
    if (d.fin && d.fin !== 'Uni') bits.push(d.fin);
    if (+d.gsm) bits.push(d.gsm + ' g/m²');
    m.textContent = bits.join(' · ');
  });

  /* ---------- Onglets (filtre par catégorie, côté client) ---------- */
  document.querySelectorAll('[data-wl-tabs]').forEach((sec) => {
    const tabs = [...sec.querySelectorAll('[data-tab]')];
    const cards = [...sec.querySelectorAll('.wl-pc')];
    const max = +sec.dataset.max || 10;
    const rail = sec.querySelector('[data-wl-rail]');
    const track = sec.querySelector('[data-track]');
    const more = sec.querySelector('[data-more]');
    const show = (cat, anim) => {
      let n = 0;
      let o = 0;
      cards.forEach((c) => {
        const ok = (cat === '*' || c.dataset.cat === cat) && n < max;
        if (ok) n++;
        c.hidden = !ok;
        if (ok && anim) {
          c.classList.remove('wl-in');
          c.style.setProperty('--d', Math.min(o++, 6) * 45 + 'ms');
          void c.offsetWidth;
          c.classList.add('wl-in');
        }
      });
      tabs.forEach((t) => t.setAttribute('aria-selected', String(t.dataset.tab === cat)));
      if (more) {
        const t = tabs.find((x) => x.dataset.tab === cat);
        if (t && t.dataset.href) more.href = t.dataset.href;
      }
      if (track) track.scrollTo({ left: 0 });
      if (rail && rail.__sync) requestAnimationFrame(rail.__sync);
    };
    // n'affiche que les onglets qui ont au moins 2 produits
    tabs.forEach((t) => {
      if (t.dataset.tab === '*') return;
      const c = cards.filter((x) => x.dataset.cat === t.dataset.tab).length;
      const s = t.querySelector('small');
      if (s) s.textContent = Math.min(c, max);
      if (c < 2) t.remove();
    });
    sec.querySelectorAll('[data-tab]').forEach((t) => t.addEventListener('click', () => show(t.dataset.tab, true)));
    show('*', false);
  });

  /* ---------- Vidéos : lecture seulement à l'écran ---------- */
  const reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;
  const save = navigator.connection && navigator.connection.saveData;
  const vids = document.querySelectorAll('video[data-wl-auto]');
  if ('IntersectionObserver' in window && !reduce && !save) {
    const io = new IntersectionObserver(
      (es) =>
        es.forEach((e) => {
          const v = e.target;
          if (e.isIntersecting) {
            if (v.preload === 'none') v.preload = 'auto';
            const p = v.play();
            if (p && p.catch) p.catch(() => {});
          } else v.pause();
        }),
      { threshold: 0.3 }
    );
    vids.forEach((v) => io.observe(v));
  }
  // 720p introuvable → source d'origine
  vids.forEach((v) => {
    const s = v.querySelector('source[data-fallback]');
    if (s && s.dataset.fallback !== s.src)
      s.addEventListener('error', () => {
        s.src = s.dataset.fallback;
        s.removeAttribute('data-fallback');
        v.load();
      }, { once: true });
  });


  /* ---------- Ils portent WOD.LOL : filtres, lire la suite, zoom photo ---------- */
  document.querySelectorAll('[data-wl-revs]').forEach((sec) => {
    const cards = [...sec.querySelectorAll('.wl-rev2')];
    const chips = [...sec.querySelectorAll('[data-rf]')];
    const rail = sec.querySelector('[data-wl-rail]');
    const track = sec.querySelector('[data-track]');
    chips.forEach((c) => {
      const k = c.dataset.rf;
      const n = k === '*' ? cards.length : cards.filter((x) => x.dataset.tags.includes(',' + k + ',')).length;
      const sm = c.querySelector('small');
      if (sm) sm.textContent = n;
      if (k !== '*' && n === 0) c.remove();
      c.addEventListener('click', () => {
        let o = 0;
        cards.forEach((x) => {
          const ok = k === '*' || x.dataset.tags.includes(',' + k + ',');
          x.hidden = !ok;
          if (ok) {
            x.classList.remove('wl-in');
            x.style.setProperty('--d', Math.min(o++, 5) * 50 + 'ms');
            void x.offsetWidth;
            x.classList.add('wl-in');
          }
        });
        chips.forEach((y) => y.setAttribute('aria-selected', String(y === c)));
        if (track) track.scrollTo({ left: 0, behavior: 'smooth' });
        if (rail && rail.__sync) requestAnimationFrame(rail.__sync);
        requestAnimationFrame(clampAll);
      });
    });
    const clampAll = () =>
      cards.forEach((x) => {
        const q = x.querySelector('[data-clamp]');
        const b = x.querySelector('[data-rmore]');
        if (!q || !b || x.hidden || q.dataset.open) return;
        q.classList.add('is-clamped');
        b.hidden = q.scrollHeight <= q.clientHeight + 2;
      });
    sec.addEventListener('click', (e) => {
      const more = e.target.closest('[data-rmore]');
      if (more) {
        const q = more.parentElement.querySelector('[data-clamp]');
        q.classList.remove('is-clamped');
        q.dataset.open = '1';
        more.hidden = true;
        return;
      }
      const z = e.target.closest('[data-zoom]');
      if (z) {
        const box = document.createElement('div');
        box.className = 'wl-zoom';
        box.setAttribute('role', 'dialog');
        box.setAttribute('aria-label', 'Photo client');
        box.innerHTML = '<img alt="Photo client" src="' + z.dataset.zoom + '">';
        const close = () => {
          box.classList.remove('is-open');
          setTimeout(() => box.remove(), 250);
          removeEventListener('keydown', esc);
        };
        const esc = (ev) => ev.key === 'Escape' && close();
        box.addEventListener('click', close);
        addEventListener('keydown', esc);
        document.body.appendChild(box);
        requestAnimationFrame(() => box.classList.add('is-open'));
      }
    });
    clampAll();
    addEventListener('resize', clampAll);
  });

  /* ---------- Vu sur les réseaux : lecteur stories ---------- */
  document.querySelectorAll('[data-wl-social]').forEach((sec) => {
    const items = [...sec.querySelectorAll('[data-reel]')];
    if (!items.length) return;
    const ico = {
      x: '<svg viewBox="0 0 14 14" width="14" height="14"><path d="M1 1l12 12M13 1L1 13" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/></svg>',
      off: '<svg class="is-off" viewBox="0 0 24 24" width="18" height="18"><path d="M4 9v6h4l5 4V5L8 9H4z" fill="currentColor"/><path d="M17 9l4 6M21 9l-4 6" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/></svg>',
      on: '<svg class="is-on" viewBox="0 0 24 24" width="18" height="18"><path d="M4 9v6h4l5 4V5L8 9H4z" fill="currentColor"/><path d="M16.5 8.5a5 5 0 010 7M19 6a8.5 8.5 0 010 12" stroke="currentColor" stroke-width="1.8" fill="none" stroke-linecap="round"/></svg>',
      l: '<svg viewBox="0 0 10 16" width="10" height="16"><path d="M8 2L2 8l6 6" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg>',
      r: '<svg viewBox="0 0 10 16" width="10" height="16"><path d="M2 2l6 6-6 6" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg>',
    };
    const box = document.createElement('div');
    box.className = 'wl-h wl-story';
    box.hidden = true;
    box.setAttribute('role', 'dialog');
    box.setAttribute('aria-modal', 'true');
    box.setAttribute('aria-label', 'Vidéos WOD.LOL');
    box.innerHTML =
      '<button type="button" class="wl-story__nav wl-story__nav--prev" data-s="prev" aria-label="Vidéo précédente">' + ico.l + '</button>' +
      '<div class="wl-story__stage">' +
      '<video class="wl-story__v" playsinline preload="auto"></video>' +
      '<div class="wl-story__bars">' + items.map(() => '<span><i></i></span>').join('') + '</div>' +
      '<div class="wl-story__head"><span class="wl-reel__ava">W</span><span class="wl-story__who">wod.lol</span>' +
      '<button type="button" class="wl-story__ctl" data-s="mute" aria-pressed="true" aria-label="Couper le son">' + ico.off + ico.on + '</button>' +
      '<button type="button" class="wl-story__ctl" data-s="close" aria-label="Fermer">' + ico.x + '</button></div>' +
      '<button type="button" class="wl-story__tap wl-story__tap--prev" data-s="prev" aria-label="Précédente"></button>' +
      '<button type="button" class="wl-story__tap wl-story__tap--next" data-s="next" aria-label="Suivante"></button>' +
      '<div class="wl-story__foot"><p class="wl-story__cap"></p><a class="wl-story__prod" hidden></a></div>' +
      '</div>' +
      '<button type="button" class="wl-story__nav wl-story__nav--next" data-s="next" aria-label="Vidéo suivante">' + ico.r + '</button>';
    document.body.appendChild(box);
    const v = box.querySelector('video');
    const bars = [...box.querySelectorAll('.wl-story__bars i')];
    const cap = box.querySelector('.wl-story__cap');
    const prod = box.querySelector('.wl-story__prod');
    const mute = box.querySelector('[data-s="mute"]');
    let i = 0;
    let sound = true;
    const esc = (t) => String(t || '').replace(/[&<>"]/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' })[c]);
    const load = (n) => {
      i = (n + items.length) % items.length;
      const d = items[i].dataset;
      bars.forEach((b, k) => b.style.setProperty('--p', k < i ? '100%' : '0%'));
      v.poster = d.poster || '';
      v.src = d.src;
      v.onerror = () => {
        if (d.srcFull && v.src !== d.srcFull) {
          v.src = d.srcFull;
          v.play().catch(() => {});
        }
      };
      v.muted = !sound;
      mute.setAttribute('aria-pressed', String(sound));
      v.play().catch(() => {
        // lecture avec son refusée par le navigateur → muet
        v.muted = true;
        sound = false;
        mute.setAttribute('aria-pressed', 'false');
        v.play().catch(() => {});
      });
      cap.textContent = d.caption || '';
      cap.hidden = !d.caption;
      if (d.pUrl) {
        prod.hidden = false;
        prod.href = d.pUrl;
        prod.innerHTML = (d.pImg ? '<img src="' + d.pImg + '" alt="">' : '<span></span>') +
          '<span><span class="wl-story__pt">' + esc(d.pTitle) + '</span><span class="wl-story__pp">' + esc(d.pPrice) + '</span></span>' +
          '<span class="wl-story__go">Voir</span>';
      } else prod.hidden = true;
    };
    v.addEventListener('timeupdate', () => {
      if (v.duration) bars[i].style.setProperty('--p', (v.currentTime / v.duration) * 100 + '%');
    });
    v.addEventListener('ended', () => (i < items.length - 1 ? load(i + 1) : close()));
    let last = null;
    const open = (n) => {
      last = document.activeElement;
      sound = true;
      box.hidden = false;
      document.documentElement.classList.add('wl-story-lock');
      sec.querySelectorAll('video').forEach((x) => x.pause());
      requestAnimationFrame(() => box.classList.add('is-open'));
      load(n);
      mute.focus({ preventScroll: true });
    };
    const close = () => {
      v.pause();
      box.classList.remove('is-open');
      document.documentElement.classList.remove('wl-story-lock');
      setTimeout(() => {
        box.hidden = true;
        v.removeAttribute('src');
        v.load();
      }, 300);
      if (last) last.focus({ preventScroll: true });
    };
    items.forEach((b) => b.addEventListener('click', () => open(+b.dataset.reel)));
    box.addEventListener('click', (e) => {
      const b = e.target.closest('[data-s]');
      if (!b) {
        if (e.target === box) close();
        return;
      }
      const a = b.dataset.s;
      if (a === 'close') close();
      else if (a === 'next') (i < items.length - 1 ? load(i + 1) : close());
      else if (a === 'prev') load(Math.max(0, i - 1));
      else if (a === 'mute') {
        sound = !sound;
        v.muted = !sound;
        b.setAttribute('aria-pressed', String(sound));
        b.setAttribute('aria-label', sound ? 'Couper le son' : 'Activer le son');
      }
    });
    addEventListener('keydown', (e) => {
      if (box.hidden) return;
      if (e.key === 'Escape') close();
      if (e.key === 'ArrowRight') (i < items.length - 1 ? load(i + 1) : close());
      if (e.key === 'ArrowLeft') load(Math.max(0, i - 1));
    });
    // glisser vers le bas pour fermer, gauche/droite pour naviguer ; appui long = pause
    const stage = box.querySelector('.wl-story__stage');
    let sx = 0, sy = 0, hold = 0;
    stage.addEventListener('touchstart', (e) => {
      sx = e.touches[0].clientX;
      sy = e.touches[0].clientY;
      hold = setTimeout(() => v.pause(), 250);
    }, { passive: true });
    stage.addEventListener('touchend', (e) => {
      clearTimeout(hold);
      if (v.paused && !v.ended) v.play().catch(() => {});
      const dx = e.changedTouches[0].clientX - sx;
      const dy = e.changedTouches[0].clientY - sy;
      if (dy > 90 && Math.abs(dy) > Math.abs(dx)) close();
      else if (Math.abs(dx) > 60) dx < 0 ? (i < items.length - 1 ? load(i + 1) : close()) : load(Math.max(0, i - 1));
    });
  });

  /* ---------- L'ADN : lire plus ---------- */
  document.querySelectorAll('[data-wl-adn]').forEach((sec) => {
    const btn = sec.querySelector('[data-adn-more]');
    if (!btn) return;
    btn.addEventListener('click', () => {
      const open = sec.classList.toggle('is-open');
      btn.textContent = open ? 'Réduire' : 'Lire plus';
      btn.setAttribute('aria-expanded', String(open));
    });
  });
})();
